/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const INSTITUTION_TYPE = "institution"
export const INSTITUTION_DATE_FORMAT_DEFAULT = "MMM DD, YYYY"

export function isInstitutionNodeData(nodeData) {
	return nodeData?.type === INSTITUTION_TYPE
}
